import axios from "axios";
import { endSession, redirectToLogin } from "../utils/session";

/**
 * Cria a instância axios usada pelos repositories.
 *
 * Além do baseURL/timeout, registra um interceptor que derruba a sessão
 * quando a API responde 401: sem isso, um token expirado continuava no
 * localStorage e o usuário seguia navegando em telas vazias como se
 * estivesse logado.
 */
export function createHttpClient({ timeout = 300000 } = {}) {
	const instance = axios.create({
		baseURL: process.env.REACT_APP_BASE_URL,
		timeout,
	});

	instance.interceptors.response.use(
		(response) => response,
		(error) => {
			const url = error.config?.url ?? "";
			// Rotas em que um 401 significa "credencial errada agora", e não
			// "sessão expirada": derrubar a sessão nelas tiraria do ar quem
			// só digitou a senha errada.
			const isCredentialCheck =
				url.includes("auth/login") || url.includes("auth/change-password");

			if (error.response?.status === 401 && !isCredentialCheck) {
				endSession().finally(redirectToLogin);
			}

			return Promise.reject(error);
		}
	);

	return instance;
}
